export default class MiniCart {
  constructor(component) {
    this.dom = {
      $component: component,
      $miniCart: component,
      $miniCartBtn: document.querySelector('.js-miniCartOpen'),
      $miniCartUnderlay: document.querySelector('.js-miniCartUnderlay'),
      $miniCartToggle: document.querySelectorAll('.js-miniCartToggle'),
      $body: document.querySelector('body'),
    }
    this.state = {
      miniCartOpen: false,
      miniCartOpenClass: 'openMiniCart',
      underlayActiveClass: 'isActive',
      bodyFixedClass: 'bodyFixed',
    }
    this.miniCartBtnClickHandler = this.miniCartBtnClick.bind(this)
    this.toggleMiniCartHandler = this.toggleMiniCart.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom } = this
    dom.$miniCartBtn.addEventListener('click', this.miniCartBtnClickHandler)
    dom.$miniCartToggle.forEach($toggle => $toggle.addEventListener('click', this.toggleMiniCartHandler))
  }

  miniCartBtnClick() {
    if (window.location.pathname.includes('/cart')) {
      return location.reload()
    }
    this.toggleMiniCart()
  }

  toggleMiniCart() {
    const { dom, state } = this

    if (state.miniCartOpen) {
      dom.$miniCart.setAttribute('aria-hidden', 'true')
      dom.$miniCart.setAttribute('aria-expanded', 'false')
      dom.$miniCart.classList.remove(state.miniCartOpenClass)
      dom.$miniCartUnderlay.classList.remove(state.underlayActiveClass)
      dom.$body.classList.remove(state.bodyFixedClass)
      state.miniCartOpen = false
    } else {
      dom.$miniCart.setAttribute('aria-hidden', 'false')
      dom.$miniCart.setAttribute('aria-expanded', 'true')
      dom.$miniCart.classList.add(state.miniCartOpenClass)
      dom.$miniCartUnderlay.classList.add(state.underlayActiveClass)
      if (window.innerWidth <= 600) {
        dom.$body.classList.add(state.bodyFixedClass)
      }
      state.miniCartOpen = true
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.MiniCart = this
  }
}
